import { createFileRoute } from '@tanstack/react-router'
import SSS from '@/modules/sss'

export const Route = createFileRoute('/_authenticated/sss/')({
  component: SSS,
})
